import numberFieldTemplate from './numberField.html';

const numberField = {

    bindings: {
        modal: '=',
        maxLength: '@',
        readOnly: '=?'
    },
    template: numberFieldTemplate,
    controller: function () {

        this.$onInit = () => {
            this.oldModal = angular.copy(this.modal);
        }
        this.checkLength = () => {
            if (this.modal && this.modal.toString().length > this.maxLength) {
                this.modal = angular.copy(this.oldModal);
            } else {
                this.oldModal = angular.copy(this.modal);
            }
        }
    }
}

export default numberField;




/** WEBPACK FOOTER **
 ** ./src/app/directives/numberField/numberField.js
 **/